// extracted by mini-css-extract-plugin
export default {"contentWrapper":"LeaveAlert_contentWrapper__8Sffl","imgWrapper":"LeaveAlert_imgWrapper__l5rVp","text":"LeaveAlert_text__gmw8V"};